import { IDynamicLinkedServiceTypeMetadata } from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';
import { azuerFileNewAuthOptions, calAzureFileStorageMetadata } from './azure-file-storage-metadata';

export const azureFileStorageMetadataAdms: IDynamicLinkedServiceTypeMetadata = async (injector) => {
    return await calAzureFileStorageMetadata(injector, azuerFileNewAuthOptions, true, 'ADMS');
};
